<script setup lang="ts">
import AppVersionBadge from './AppVersionBadge.vue';
</script>

<template>
	<header
		class="relative z-40 w-full min-w-0 shrink-0 overflow-hidden border-b border-border-subtle bg-primary lg:hidden"
		style="padding-top: var(--safe-area-top)"
	>
		<div class="grid h-14 w-full min-w-0 grid-cols-[4.5rem_1fr_4.5rem] items-center px-md">
			<div class="flex h-8 w-8 items-center justify-center">
				<slot name="leading" />
			</div>

			<div class="flex min-h-0 min-w-0 items-center justify-center overflow-hidden px-1">
				<slot name="center" />
			</div>

			<div class="flex items-center justify-end">
				<slot name="trailing">
					<AppVersionBadge class="text-white/80" />
				</slot>
			</div>
		</div>
	</header>
</template>
